import { Information } from '@carbon/icons-react'
import {
  Button,
  Box,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'

export const PeakDetails = () => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  return (
    <>
      <Button
        minWidth={'150px'}
        maxW='150px'
        variant='clean'
        mr='auto'
        onClick={onOpen}
        fontSize='12px'
        alignItems={'center'}
      >
        <Box mr={1}>
          <Information />
        </Box>
        <Text
          variant='body'
          textDecor={'underline'}
          color='gray1'
          width='fit-content'
          whiteSpace={'break-spaces'}
          textAlign={'left'}
        >
          How is this calculated?
        </Text>
      </Button>
      <Modal
        blockScrollOnMount={false}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxH='75vh' overflow='auto' width='100%' minW='1000px'>
          <ModalCloseButton />
          <ModalBody>
            <Box className='gap-3 w-[70%] max-w-[700px] flex flex-col m-auto border border-gray-200 p-6 bg-gray-50 rounded leading-relaxed'>
              <Text as='h3' fontSize='2xl' my={3} fontWeight='bold'>
                Peak Calculation Methodology
              </Text>
              <Text mb={4}>
                Airfinity calculates peaks using different methodologies
                depending on the disease characteristics and epidemiological
                patterns. For seasonal respiratory diseases such as influenza
                and RSV, we use a seasonal approach that reflects the natural
                epidemiological cycles of these pathogens. Peak identification
                is based on seasonal periods running from September 1st through
                May 31st of the following year, corresponding to typical
                northern hemisphere respiratory disease seasons. Within each
                seasonal period, the algorithm identifies the highest test
                positivity value as the seasonal peak.
              </Text>
              <Text mb={4}>
                For COVID-19, which exhibits irregular outbreak patterns, we
                employ a sophisticated divide-and-conquer peak detection
                algorithm that applies centered moving average smoothing to
                reduce noise in the data. The algorithm validates peaks using a
                50% retrace rule, ensuring that any identified peak experiences
                a subsequent decline of at least half the magnitude of its rise.
                A minimum 45-day separation is maintained between peaks to
                prevent over-identification during periods of high volatility.
              </Text>
              <Text mb={4}>
                The system adapts to both daily and weekly data intervals,
                adjusting parameters accordingly. Peak timing and magnitude can
                be influenced by testing policies and reporting delays that vary
                between countries.
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
